import { useNavigate, useParams } from 'react-router-dom';
import { routePaths } from 'src/app-routes';
import { ModelStepPageParams } from '../../model-step.types';

export const useModelNavigation = () => {
  const { id, stepNumber } = useParams<ModelStepPageParams>();

  const stepNumberValue = Number(stepNumber);

  const navigate = useNavigate();

  const onNavigateToModelStep = (stepNumber: number) => {
    navigate(
      routePaths.designFlowModelStep({
        id,
        stepNumber,
      }),
    );
  };

  const onNavigateToPrev = () => {
    onNavigateToModelStep(stepNumberValue - 1);
  };

  const onNavigateToNext = () => {
    onNavigateToModelStep(stepNumberValue + 1);
  };

  const onNavigateToStepList = () => {
    navigate(routePaths.designFlowStepList(id));
  };

  const onNavigateToSubmitModel = () => {
    navigate(routePaths.designFlowSubmitModel(id));
  };

  const onNavigateToDesigns = () => {
    navigate(routePaths.designs);
  };

  return {
    onNavigateToDesigns,
    onNavigateToModelStep,
    onNavigateToNext,
    onNavigateToPrev,
    onNavigateToStepList,
    onNavigateToSubmitModel,
  };
};
